import React, { useState } from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

const DocumentUpload: React.FC = () => {
    const [file, setFile] = useState<File | null>(null);
    const [msg, setMsg] = useState<string>('');
    const [url, setUrl] = useState<string>('');
    const navigate = useNavigate();

    const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return setMsg('Selecione um arquivo');
        try {
            setMsg('Enviando...');
            const f = new FormData();
            f.append('file', file);
            const res = await api.post('/api/signatures/upload', f, { headers: { 'Content-Type': 'multipart/form-data' } });
            setUrl(res.data.url);
            setMsg('Upload concluído');
        } catch (err) {
            console.error(err);
            setMsg('Erro no upload');
        }
    };

    return (
        <Box sx={{ p: 2 }}>
            <Paper sx={{ p: 2 }}>
                <Typography variant="h6">Upload de Documento</Typography>
                <Box sx={{ mt: 2 }}>
                    <input type="file" onChange={handleFile} />
                    <Button sx={{ ml: 2 }} variant="contained" onClick={handleUpload}>Enviar</Button>
                    {url && <Button sx={{ ml: 2 }} onClick={() => navigate('/assinaturas', { state: { documentUrl: url } })}>Criar assinatura com este arquivo</Button>}
                </Box>
                {msg && <Typography sx={{ mt: 2 }}>{msg}</Typography>}
                {url && <Typography sx={{ mt: 1 }}>URL: <a href={url} target="_blank" rel="noreferrer">{url}</a></Typography>}
            </Paper>
        </Box>
    );
};

export default DocumentUpload;
